import { makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import { useState, useEffect, FC, useMemo } from 'react';

import { FootnoteDefinition, LabelControlDefinition } from '../services/layout';

import { TemplatedText } from './TemplatedText';
import { FormControlProps } from "../utils";
import { Footnote } from './Footnote';
import React from 'react';

export interface LabelProps extends FormControlProps<LabelControlDefinition> {
}

const useStyles = makeStyles(function (theme: Theme) {
  return createStyles({
    root: {
      margin: theme.spacing(1, 0, 1, 0),
      [theme.breakpoints.down('sm')]: {
        marginBottom(props: any) {
          return props.definition.footnote?.inline ? theme.spacing(2) : theme.spacing(1);
        }
      },
      position: 'relative',
      flex: 1,
    },
    text: function (props: any) {
      const style = props.definition.style;
      const styles = {
        [theme.breakpoints.down('sm')]: {
          marginBottom(props: any) {
            return props.definition.footnote?.inline ? '-18px' : 0;
          }
        }
      };
      if (style?.textAlign) {
        styles.textAlign = style.textAlign
      }
      return styles;
    },
    buttonWrapper: {
      width: '100%',
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
    },
    button: {
      padding: 0,
      color: theme.palette.primary.main,
      border: 'none',
      background: 'none',
      textDecoration: 'underline',
      cursor: 'pointer',
      position: 'absolute',
      right: theme.spacing(6)
    },
  });
});

export const Label: FC<LabelProps> = function (props) {
  const definition = props.definition;
  const classes = useStyles(props);
  const [ shortText, setShortText ] = useState(true);

  useEffect(function resetText() {
    // Necessary so that when the label is reused it does not inherit an improper state
    setShortText(true);
  }, [definition]);

  const hasLongVersion = definition.longText !== undefined;
  let button;

  if (hasLongVersion) {
    const buttonText = shortText
      ? definition.longText!.revealLabel || 'Full Question'
      : definition.longText!.hideLabel || 'Short Question';
    button = (
      <button
        className = { classes.button }
        onClick = { () => setShortText(!shortText) }>
        <Typography  variant = { 'caption' }>
          { buttonText }
        </Typography>
      </button>
    )
  }
  else {
    button = null;
  }
  // const text = useMemo(() => {
  //   return (
  //     <TemplatedText
  //       className = { classes.text }
  //       template = { shortText ? definition.template : definition.longText?.template ?? '' }
  //       params = { shortText ? definition.params : definition.longText?.params }>
  //         <div className = { classes.actions }>
  //           { definition.footnote &&
  //             <Footnote { ...definition.footnote }></Footnote>
  //             // seems like an ide problem
  //             // { button }
  //           }
  //       </div>
  //     </TemplatedText>
  //   )
  // }, [definition])

  return (
    <div className = { classes.root }>
      <TemplatedText
        className = { classes.text }
        template = { shortText ? definition.template : definition.longText?.template ?? '' }
        params = { shortText ? definition.params : definition.longText?.params }>
      </TemplatedText>
      { definition.footnote && (
        !Array.isArray(definition.footnote)
          ? <Footnote {...definition.footnote as FootnoteDefinition }></Footnote>
          : definition.footnote.map((f: any, i: number) =>
            <Footnote revealLabel={f.revealLabel} text={f.text} key={ i }></Footnote>
          )
      )}
    </div>
  );
};
// registry.registerComponent('Label', Label);

// todo either just overwrite label or make a new component that accepts 2 footnotes
